import { AuraHeaderBar } from "@/components/aura/AuraHeaderBar";
import { AuraUpdatedAnswersPanel } from "@/components/aura/AuraUpdatedAnswersPanel";
import { StatusBanner } from "@/components/common/StatusBanner";

export function SwingLabDesignMockPage() {
  const limits = { maxSeconds: 15, maxRes: '1080p' as const, maxSizeMB: 250 };

  return (
    <div className="bg-neutral-50 text-slate-800 antialiased min-h-screen">
      <AuraHeaderBar />
      
      <main className="max-w-4xl mx-auto px-5 pb-24">
        <div className="pt-6">
          <StatusBanner
            type="warning"
            title="Design Mock Only"
            description="This is a composition of Aura components for design review. Wiring begins in Step 2."
            className="mb-6"
          />
        </div>

        <AuraUpdatedAnswersPanel limits={limits} />
        
        <section className="pt-8">
          <h1 className="text-3xl md:text-4xl tracking-tight font-semibold text-slate-900 mb-4">
            Swing Lab Design Mock
          </h1>
          <p className="text-[15px] text-slate-600 mb-8">
            Compact composition using Aura components with 15s/1080p limits configured.
          </p>
          
          <div className="rounded-2xl border border-slate-200 bg-white shadow-sm p-6">
            <h3 className="text-lg font-semibold text-slate-900 mb-4">Mock Configuration</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm">
              <div className="p-3 bg-slate-50 rounded-lg">
                <div className="font-medium text-slate-900">Max Duration</div>
                <div className="text-slate-600">{limits.maxSeconds} seconds</div>
              </div>
              <div className="p-3 bg-slate-50 rounded-lg">
                <div className="font-medium text-slate-900">Max Resolution</div>
                <div className="text-slate-600">{limits.maxRes}</div>
              </div>
              <div className="p-3 bg-slate-50 rounded-lg">
                <div className="font-medium text-slate-900">Max File Size</div>
                <div className="text-slate-600">{limits.maxSizeMB}MB</div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}